export default __webpack_public_path__ + "images/0xfbdd194376de19a88118e84e279b977f165d01b8.png";